import api from 'common/api';
import {
  SearchMenuAuthorityMasterRequest,
  DetailMenuAuthorityMasterRequest,
  UpdateMenuAuthorityMasterRequest,
} from 'api-types/src/types/menu-authority-master';

export const getMenuAuthorityAPI = (params: SearchMenuAuthorityMasterRequest) =>
  api.get('/menu-authority-master/list', params);

export const getMenuAuthorityDetailAPI = (params: DetailMenuAuthorityMasterRequest) =>
  api.get('/menu-authority-master/detail', params);

export const getScreenListAPI = () => api.get('/menu-authority-master/screen-list');

export const numberingAPI = () => api.get('/menu-authority-master/numbering');

export const addMenuAuthorityAPI = (params: UpdateMenuAuthorityMasterRequest) =>
  api.put('/menu-authority-master/add', params);

export const updateMenuAuthorityAPI = (params: UpdateMenuAuthorityMasterRequest) =>
  api.put('/menu-authority-master/update', params);

export const deleteMenuAuthorityAPI = (params: UpdateMenuAuthorityMasterRequest) =>
  api.put('/menu-authority-master/delete', params);

export const DOWNLOAD_EXCEL_MENU_AUTHORITY_MAST = '/menu-authority-master/list';
